import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Button, Paper } from '@material-ui/core';
import MerchantLayout from '../../layout/MerchantLayout';
import { useAuth } from '../../hooks/useAuth';

const MerchantUserInfoPage: React.FC = () => {
  const { logoutAndRedirect } = useAuth();

  return (
    <MerchantLayout>
      <Typography variant="h1" color="primary">
        Decision time!
      </Typography>
      <Paper style={{ justifyContent: 'center', placeItems: 'center', maxWidth: '600px'}}>
        <Grid
          container
          direction="column"
          justifyContent="space-around"
          alignItems="center"
        >
          <Grid item xs={6} md={6}>
            <Typography variant="h3" color="primary">
              You are currently logged in as a SejutaKG Member.  To login as a Merchant, you will need to log out.
            </Typography>
          </Grid>
          <Grid item xs={6} md={6}>
            <Typography>
              To proceed to the Merchant Data Terminal, click below. 
            </Typography>
            <Button variant="contained" color="primary" onClick={() => logoutAndRedirect("/login")}>Logout</Button>
          </Grid>
          <Grid item xs={6} md={6}>
            <Typography>
              To remain logged in as a SejutaKG Member, click below.
            </Typography>
            <Button variant="contained" color="primary" onClick={() => window.location.replace('/')}>Remain logged in as a SejutaKG Member.</Button>
          </Grid>
        </Grid>
      </Paper>
    </MerchantLayout >
  );
};

export default MerchantUserInfoPage;
